<template>
    <div class="container">
        <!-- <p id="titleTop">视知觉能力测试</p>
        <p id="titleBottom">第8节&nbsp;&nbsp;色觉敏感度测试</p> -->
        <p id="titleTop">视知觉能力测试<span id="titleBottom">&nbsp;---&nbsp;第8节&nbsp;&nbsp;色觉敏感度测试</span></p>
        <div id="progressContainer">
            <p v-show="!$store.state.global.isTest">{{pw+'%'}}</p>
            <p v-show="$store.state.global.isTest">练习中</p>
            <div id="progressContent" :style="`width:${pw}%`"></div>
        </div>
        <div id="colorBlockContainer">
            <canvas id="canvas" width="240" height="240" @click=onSelectBlock></canvas>
        </div>
        <img v-show="tipImgBol" id="tipImg" :src="tipImgUrl" alt="">
        <audio id="zhunqueAudio" src="../../assets/sound/zhunque.mp3"></audio>
    </div>
    
</template>

<script>
    export default {
        name:'Sejue',
        data(){
            return{
                pw:0,
                roundNum:null,
                pointNum:null,
                colorArr:[
                    [
                        [[34,175,82],[55,205,111]],
                        [[177,143,137],[207,173,167]],
                        [[145,230,50],[160,245,59]],
                        [[232,177,143],[248,191,158]],
                        [[77,126,168],[108,156,198]]
                    ],
                    [
                        [[152,100,100],[162,116,116]],
                        [[82,176,86],[98,184,102]],
                        [[69,82,175],[88,99,184]],
                        [[191,60,62],[193,82,62]],
                        [[118,47,251],[133,55,250]],
                        [[222,194,253],[232,194,253]],
                        [[187,198,225],[202,213,240]],
                        [[100,45,13],[115,60,27]],
                        [[25,88,52],[40,103,67]]
                    ],
                    [
                        [[250,83,158],[255,88,158]],
                        [[0,49,250],[0,58,250]],
                        [[52,252,50],[59,253,57]],
                        [[251,41,250],[251,50,251]],
                        [[255,252,51],[255,252,62]]
                    ]
                ],
                currentColorArr:[],
                tipImgUrl:'',
                tipImgBol:false
            }
        },
        methods:{
            onPlayAudio(bol){
                let a;
                a=document.getElementById('zhunqueAudio')
                a.play();
            },
            //创建色块
            createColorBlock(){
                if(this.roundNum===5&&this.$store.state.global.isTest){
                    // this.$dialog.alert({
                    //     message:'测试已完成!',
                    // }).then(()=>{
                    //     this.$router.push('/commonDescription')
                    // })
                    this.$router.push('/sejueDescription')
                    return
                }

                let c=document.getElementById('canvas')
                let ctx=document.getElementById('canvas').getContext('2d');
                //获取点击位置的颜色值
                // console.log(ctx.getImageData(e.offsetX,e.offsetY,1,1))
                if(this.roundNum<=5){
                    this.roundNum++

                    ctx.clearRect(0,0,c.width,c.height)
                    //确定不同的色块位置
                    let specialArr=[Math.floor(Math.random()*3),Math.floor(Math.random()*3)];
                    //确定用哪一组颜色
                    let colorArr=this.colorArr[0][Math.floor(Math.random()*5)];
                    this.currentColorArr=colorArr
                    for(let i=0;i<3;i++){
                        for(let j=0;j<3;j++){
                            if(i===specialArr[0]&&j===specialArr[1]){
                                this.fillRoundRect(ctx,(i*80)+2,(j*80)+2,76,76,10,'rgb('+colorArr[1][0]+','+colorArr[1][1]+','+colorArr[1][2]+')');
                            }
                            else{
                                this.fillRoundRect(ctx,(i*80)+2,(j*80)+2,76,76,10,'rgb('+colorArr[0][0]+','+colorArr[0][1]+','+colorArr[0][2]+')');
                            }
                        }
                    }
                }
                else if(this.roundNum<=15){
                    this.roundNum++
                    ctx.clearRect(0,0,c.width,c.height)
                    //确定不同的色块位置
                    let specialArr=[Math.floor(Math.random()*4),Math.floor(Math.random()*4)];
                    //确定用哪一组颜色
                    let colorArr=this.colorArr[1][Math.floor(Math.random()*9)];
                    this.currentColorArr=colorArr
                    for(let i=0;i<4;i++){
                        for(let j=0;j<4;j++){
                            if(i===specialArr[0]&&j===specialArr[1]){
                                this.fillRoundRect(ctx,(i*60)+2,(j*60)+2,56,56,10,'rgb('+colorArr[1][0]+','+colorArr[1][1]+','+colorArr[1][2]+')');
                            }
                            else{
                                this.fillRoundRect(ctx,(i*60)+2,(j*60)+2,56,56,10,'rgb('+colorArr[0][0]+','+colorArr[0][1]+','+colorArr[0][2]+')');
                            }
                        }
                    }
                }
                else if(this.roundNum<=20){
                    this.roundNum++
                    ctx.clearRect(0,0,c.width,c.height)
                    //确定不同的色块位置
                    let specialArr=[Math.floor(Math.random()*5),Math.floor(Math.random()*5)];
                    //确定用哪一组颜色
                    let colorArr=this.colorArr[2][Math.floor(Math.random()*5)];
                    this.currentColorArr=colorArr
                    for(let i=0;i<5;i++){
                        for(let j=0;j<5;j++){
                            if(i===specialArr[0]&&j===specialArr[1]){
                                this.fillRoundRect(ctx,(i*48)+2,(j*48)+2,44,44,10,'rgb('+colorArr[1][0]+','+colorArr[1][1]+','+colorArr[1][2]+')');
                            }
                            else{
                                this.fillRoundRect(ctx,(i*48)+2,(j*48)+2,44,44,10,'rgb('+colorArr[0][0]+','+colorArr[0][1]+','+colorArr[0][2]+')');
                            }
                        }
                    }
                }
                this.pw=Math.floor((this.roundNum/20)*100)
            },
            //绘制圆角矩形
            fillRoundRect(cxt,x,y,width,height,radius,fillColor){
                cxt.save()
                cxt.translate(x,y)
                //绘制圆角矩形的各个边  
                this.drawRoundRectPath(cxt,width,height,radius)
                cxt.fillStyle=fillColor//若是给定了值就用给定的值否则给予默认值  
                cxt.fill();
                cxt.restore();
            },
            drawRoundRectPath(cxt,width,height,radius){
                cxt.beginPath(0);
                //从右下角顺时针绘制，弧度从0到1/2PI  
                cxt.arc(width-radius,height-radius,radius,0,Math.PI/2);
                //矩形下边线  
                cxt.lineTo(radius,height);
                //左下角圆弧，弧度从1/2PI到PI  
                cxt.arc(radius,height-radius,radius,Math.PI/2,Math.PI);
                //矩形左边线  
                cxt.lineTo(0,radius);
                //左上角圆弧，弧度从PI到3/2PI  
                cxt.arc(radius,radius,radius,Math.PI,Math.PI*3/2);
                //上边线  
                cxt.lineTo(width-radius,0);
                //右上角圆弧  
                cxt.arc(width-radius,radius,radius,Math.PI*3/2,Math.PI*2);
                //右边线  
                cxt.lineTo(width,height-radius);
                cxt.closePath();
            },
            //选择色块
            onSelectBlock(e){
                if(this.$store.state.global.isLoadingShow){
                    return
                }
                if(this.roundNum>20){
                    return
                }
                this.onPlayAudio(true)
                let ctx=document.getElementById('canvas').getContext('2d');
                let color=ctx.getImageData(e.offsetX,e.offsetY,1,1).data
                if(color[0]===0&&color[1]===0&&color[2]===0){
                    return
                }
                if(color[0]===this.currentColorArr[1][0]&&color[1]===this.currentColorArr[1][1]&&color[2]===this.currentColorArr[1][2]){
                    if(this.$store.state.global.isTest){
                        this.tipImgUrl=require("../../assets/correct.png")
                        this.tipImgBol=true
                        setTimeout(() => {
                            this.tipImgBol=false
                        }, 500);
                    }
                    //正确
                    this.sum(true)
                }
                else{
                    if(this.$store.state.global.isTest){
                        this.tipImgUrl=require("../../assets/error.png")
                        this.tipImgBol=true
                        setTimeout(() => {
                            this.tipImgBol=false
                        }, 500);
                    }
                    this.sum(false)
                }
                if(this.roundNum===20){
                    this.$store.state.global.isLoadingShow=true
                    this.roundNum++
                    this.$axios({
                        url:this.$store.state.global.padUrl+'/visualplatpad/detector-report/save',
                        method:'post',
                        data:{
                            "globalId": this.$store.state.global.globalId, 
                            "testType": 8, 
                            "testResult": JSON.stringify({
                                data:this.$store.state.sejue.progressData,
                                result:this.$store.state.sejue.progressData[this.$store.state.sejue.progressData.length-1][0]
                            })
                        },
                        headers:{
                            'Authorization':'Bearer '+this.$store.state.global.token,
                            'serverFlag':'',
                            'dsName':'',
                            'content-type': 'application/json'
                        }
                    }).then(
                        response=>{
                            console.log(response)
                            this.$store.state.global.isLoadingShow=false
                            this.$router.push('/checkReport')
                        },
                        error=>{
                            console.log(error)
                            this.$store.state.global.isLoadingShow=false
                            this.$dialog.alert({
                                message:'色觉敏感度提交失败，请联系管理员',
                            }).then(()=>{
                                this.$router.push('/sejueDescription')
                            })
                        }
                    )
                }
                else{
                    this.createColorBlock()
                }
            },
            sum(bol){
                if(bol){//正确
                    if(this.roundNum<=5){
                        this.pointNum+=7
                    }
                    else if(this.roundNum<=15){
                        this.pointNum+=5
                    }
                    else if(this.roundNum<=20){
                        this.pointNum+=3
                    }
                    this.$store.state.sejue.progressData.push([this.pointNum,bol])
                }
                else{
                    this.$store.state.sejue.progressData.push([this.pointNum,bol])
                }
            }
        },
        mounted(){
            this.$store.state.global.isTrans=true
            this.$store.state.sejue.progressData=[]
            this.roundNum=0
            this.pointNum=0
            // let c=document.getElementById('canvas')
            // c.width=window.innerWidth-window.innerWidth%100-(window.innerWidth-window.innerWidth%100)%60
            // c.height=c.width
            // let d=document.getElementById('colorBlockContainer')
            // d.style.width=c.width+'px'
            // d.style.height=c.width+'px'
            this.createColorBlock();
        }
    }
</script>

<style scoped>
    .container{
        background: rgb(233,233,233);
        position: absolute;
        /* top: 8%; */
        height: 100vw;
        width: 100vh;
        transform-origin: left top;
        transform: rotate(90deg);
        left:100vw;
    }
    #colorBlockContainer{
        position: absolute;
        left:50%;
        top:55%;
        transform:translate(-50%,-50%);
    }
    p{
        text-align: center;
    }
    #titleTop{
        /* padding-top: 3vw; */
        margin-top: 3vw;
        font-size: 5vw;
        font-weight: bold;
    }
    #titleBottom{
        font-size: 5vw;
        font-weight: 200;
    }
    #progressContainer{
        width: 90vh;
        height: 2vw;
        background: rgb(216,216,216);
        border-radius: 2vw;
        margin-left: 4vh;
        margin-top: 3vw;
        position: relative;
    }
    #progressContent{
        height: 2vw;
        /* color: rgb(117, 44, 44); */
        border-radius: 2vw;
        text-align: center;
        /* width: 50%; */
        background-color: #80dbff;
    }
    #progressContainer p{
        position: absolute;
        left:50%;
        top:50%;
        transform:translate(-50%,-50%);
        padding-top: 0;
        font-size: 3vw;
    }
    #tipImg{
        position: absolute;
        left:50%;
        top: 55%;
        transform:translate(-50%,-50%);
        width: 10vw;
    }
</style>